module.exports = __webpack_public_path__ + "static/media/tools-toolmode.d98d8fb4.svg";